<template>
  <StoryblokComponent
    v-if="story && !pending && !error"
    :blok="story.content"
  />
</template>

<script setup>
// Set the route
defineI18nRoute({
  paths: {
    en: '/session/[slug]',
  },
})

// Fetch the content from Storyblok
const { story, pending, error, setSEO } = useStoryblokCMS('session/:slug')

// Set the SEO
setSEO(story)
</script>
